// @ts-check
// Aviso antes de salvar os filtros de uma view da escola usada ao vivo por campanhas e fluxos (contrato 09 de público,
// seção 7): "Esta view define quem entra em 2 fluxos ativos e 1 campanha agendada. Mudar os filtros muda esse público
// agora.", como o aviso do RD ao mudar uma segmentação usada em fluxos. O motor confere as flags de novo (K45).
import { html } from 'htm/preact';
import { render } from 'preact';
import { fetchViewAudienceUsages } from '../../data/audiences.js';
import { Modal } from '../../ui/modal.js';
import { t } from '../../i18n/index.js';

/**
 * @typedef {{ total: number, live: number, byKind: Record<string, number>, items: Array<{ kind: string, id: string, name: string, isLive: boolean }> }} ViewUsages
 */

const ENROLLMENT_OBJECT = 'enrollmentOpportunity';

/**
 * Frase com os consumidores ao vivo: "2 fluxos ativos e 1 campanha agendada".
 * @param {ViewUsages} usages
 */
export function describeLiveUsages(usages) {
  const liveByKind = /** @type {Record<string, number>} */ ({});
  for (const item of usages.items.filter((usage) => usage.isLive)) liveByKind[item.kind] = (liveByKind[item.kind] ?? 0) + 1;
  const hiddenLive = usages.live - Object.values(liveByKind).reduce((sum, value) => sum + value, 0);
  const parts = Object.entries(liveByKind).map(([kind, count]) => t(`audience.viewUsage.kinds.${kind}`, { count }));
  if (hiddenLive > 0) parts.push(t('audience.viewUsage.kinds.OTHER', { count: hiddenLive }));
  if (parts.length <= 1) return parts.join('');
  return t('audience.viewUsage.join', { first: parts.slice(0, -1).join(', '), last: parts[parts.length - 1] });
}

/**
 * Pergunta antes de salvar. Resolve true quando pode salvar (sem uso ao vivo, view pessoal, outro objeto ou a pessoa
 * confirmou).
 * @param {{ id: string, visibility?: string }} view @param {{ nameSingular: string } | undefined} objectMetadata
 * @returns {Promise<boolean>}
 */
export async function confirmLiveViewSave(view, objectMetadata) {
  if (objectMetadata?.nameSingular !== ENROLLMENT_OBJECT || view.visibility === 'UNLISTED' || view.id.startsWith('fallback-')) return true;
  /** @type {ViewUsages} */
  let usages;
  try {
    usages = await fetchViewAudienceUsages(view.id);
  } catch {
    // sem a lista de usos, o motor ainda confere: salvar segue e a recusa aparece no aviso de erro
    return true;
  }
  if (usages.live === 0) return true;
  return new Promise((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    /** @param {boolean} answer */
    const close = (answer) => {
      render(null, container);
      container.remove();
      resolve(answer);
    };
    render(html`<${Modal}
      title=${t('audience.viewUsage.confirmTitle')}
      subtitle=${t('audience.viewUsage.confirmSave', { usages: describeLiveUsages(usages) })}
      confirmLabel=${t('audience.viewUsage.confirm')}
      onClose=${() => close(false)}
      onConfirm=${() => close(true)}
    />`, container);
  });
}
